import { CheckCircleIcon } from "@heroicons/react/24/solid";

export const CATEGORY_STYLE = {
  door: { band: "bg-blue-50 dark:bg-blue-950/40", label: "Door sensor" },
  environment: { band: "bg-green-50 dark:bg-green-950/40", label: "Temperature · Humidity" },
  soil: { band: "bg-amber-50 dark:bg-amber-950/40", label: "Soil" },
  generic: { band: "bg-gray-100 dark:bg-gray-800", label: "Sensor" },
};

export default function CatalogCard({ entry, selected, onSelect }) {
  const style = CATEGORY_STYLE[entry.category] || CATEGORY_STYLE.generic;
  return (
    <button
      type="button"
      aria-pressed={selected}
      onClick={onSelect}
      className={`relative overflow-hidden rounded-xl border bg-white dark:bg-gray-900 text-left transition ${
        selected ? "border-blue-600 ring-2 ring-blue-100 dark:ring-blue-500/30" : "border-gray-200 dark:border-gray-800 hover:border-gray-400"
      }`}
    >
      {selected && (
        <CheckCircleIcon className="absolute right-3 top-3 h-7 w-7 text-blue-600" aria-hidden="true" />
      )}
      <div className={`flex h-28 items-end px-5 pb-3 ${style.band}`}>
        <span className="font-mono text-xs uppercase tracking-wider text-gray-600 dark:text-gray-400">{style.label}</span>
      </div>
      <div className="px-5 py-4">
        <span className="block text-sm text-gray-500 dark:text-gray-400">{entry.make}</span>
        <span className="block text-lg font-semibold text-gray-900 dark:text-gray-50">{entry.model}</span>
        <span className="block text-sm text-gray-600 dark:text-gray-400">{entry.channels.map((c) => c.name).join(" · ")}</span>
      </div>
    </button>
  );
}
